const bootstrap = require("bootstrap");

// Get all the dropdowns in the menu
const siteHeader = document.querySelector("#masthead") || false;
const collapsibles = document.querySelectorAll("#loveli-navbar .collapse") || false;
const parents = document.querySelectorAll("#nav-main .menu-item-has-children") || false;

// Create collapsibles for menu
export const menuDropdownCollapse = (() => {
	if (!collapsibles || collapsibles.length === 0) {
		return;
	}

	// Loop through all collapsible elements within the mnu
	collapsibles.forEach((collapsible) => {
		let id = collapsible.id;

		// Set the right data-attribute
		collapsible.previousElementSibling.setAttribute("data-bs-target", `#${id}`);
	});
})();

export const mobileHideMenuOnBlur = (() => {
	const menu = document.querySelector("#loveli-navbar") || false;
	if (!menu) return;
	const menuCollapsible = bootstrap.Collapse.getOrCreateInstance(document.querySelector("#loveli-navbar"), { toggle: false });

	menu.addEventListener("shown.bs.collapse", (e) => {
		document.addEventListener("click", hideMenuOnClick);
	});

	function hideMenuOnClick(e) {
		if (!menu.querySelector(".navbar-nav").contains(e.target)) {
			menuCollapsible.hide();
			document.removeEventListener("click", hideMenuOnClick);
		}
	}
})();

export const hideToTopBtn = (() => {
	/* Hide to top button if cart is open */
	// Set variables
	const offCanvasCart = document.querySelector("#offcanvas-cart") || false;
	const toTopBtn = document.querySelector(".top-button") || false;

	if (!offCanvasCart || !toTopBtn) return;

	// Hide button when offcanvas is open
	offCanvasCart.addEventListener("show.bs.offcanvas", function () {
		toTopBtn.classList.add("opacity-0");
	});

	// Show button again when offcanvas is closed
	offCanvasCart.addEventListener("hide.bs.offcanvas", function () {
		toTopBtn.classList.remove("opacity-0");
	});
})();

export const menuDropdown = (() => {
	// Call the function because we need it on page load, but also need to export it
	setPosition();

	// Event Listener
	window.addEventListener(
		"resize",
		() => {
			setPosition();
		},
		{ passive: true }
	);

	// Set the function
	function setPosition() {
		if (siteHeader !== null) {
			document.body.style.setProperty("--dropdown-top-offset", `${siteHeader.offsetHeight}px`);
		}
	}

	// Make it public
	return {
		setPosition: setPosition,
	};
})();

// Resize logo
export const resizeLogo = (() => {
	/* Function to resize header logo based on page position */
	const logo = document.querySelector(".logo");
	const spy = document.querySelector("#scroll-spy");

	if (spy == null || logo == null) {
		return;
	}

	// Event listener to reset menu position on resizing of logo
	logo.addEventListener("transitionend", () => {
		menuDropdown.setPosition();
	});

	const collapse = [...document.querySelectorAll(".hide-on-scroll")].map(
		(collapseEl) => new bootstrap.Collapse(collapseEl, { toggle: false })
	);
	const collapseMobile = [...document.querySelectorAll(".hide-on-scroll-mobile")].map(
		(collapseEl) => new bootstrap.Collapse(collapseEl, { toggle: false })
	);

	// Set observer
	const observer = new IntersectionObserver(
		(entries) => {
			const spy = entries[0];
			document.body.classList.toggle("scrolling", !spy.isIntersecting);
		},
		{ threshold: 1 }
	);

	// Watch for changes to the scrolling class
	const classObserver = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === "attributes" && mutation.attributeName === "class") {
				const oldClasses = mutation.oldValue ? mutation.oldValue.split(" ") : [];
				const newClasses = document.body.className.split(" ");

				// Check if scrolling class was added or removed
				const wasScrolling = oldClasses.includes("scrolling");
				const isScrolling = newClasses.includes("scrolling");

				if (wasScrolling !== isScrolling) {
					collapse.forEach((collapsible) => collapsible.toggle());

					if (window.matchMedia("(max-width: 767px)").matches) {
						collapseMobile.forEach((collapsible) => collapsible.toggle());
					}
				}
			}
		});
	});

	// Start observing the body for class changes
	classObserver.observe(document.body, {
		attributes: true,
		attributeFilter: ["class"],
		attributeOldValue: true,
	});

	// Observe the spy
	observer.observe(spy);
})();
